import React from 'react';
import { useLockBodyScroll } from '@uidotdev/usehooks';

export default function LockBodyScroll() {
  useLockBodyScroll();
  return null;
}
